const showModal = id => {
  document.dispatchEvent(
    new CustomEvent("showModal", {
      detail: { id }
    })
  );
};

const hideModal = id => {
  document.dispatchEvent(
    new CustomEvent("hideModal", {
      detail: { id }
    })
  );
};

export { showModal, hideModal };
